import script from "./SplitView.vue?vue&type=script&setup=true&lang=js"
export * from "./SplitView.vue?vue&type=script&setup=true&lang=js"

import "./SplitView.vue?vue&type=style&index=0&id=7a05a14e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a05a14e"]])

export default __exports__